<template>
    <el-dialog title="请完成安全验证" :visible.sync="visible" width="360px" @opened="dialog_open">
        <div class="nc-container" id="nc-container"></div>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                visible: false,
                callback: null,
            };
        },
        created() {
            this.$event_bus.$on("captcha_verify", (callback) => {
                this.callback = callback;
                this.visible = true;
            });
        },
        methods: {
            dialog_open() {
                //验证码
                var nc_token = ["FFFF0N0N000000008717", new Date().getTime(), Math.random()].join(":");
                var NC_Opt = {
                    renderTo: "#nc-container",
                    appkey: "FFFF0N0N000000008717",
                    scene: "nc_login",
                    token: nc_token,
                    customWidth: 300,
                    trans: { key1: "code0" },
                    elementID: ["usernameID"],
                    is_Opt: 0,
                    language: "cn",
                    isEnabled: true,
                    timeout: 3000,
                    times: 5,
                    callback: (data) => {
                        //this.form.captcha = data;
                        // vm.captchaSuccess = true
                        this.callback(data);

                        this.visible = false;
                    },
                };
                var nc = new noCaptcha(NC_Opt);
                nc.upLang("cn", {
                    _startTEXT: "请按住滑块，拖动到最右边",
                    _yesTEXT: "验证通过",
                    _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                    _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
                });
            },
        },
    };
</script>
